export default (function (value) {
  return value;
});


//////////////////
// WEBPACK FOOTER
// ./~/redux-actions/es/utils/identity.js
// module id = hFCR
// module chunks = 0